import React from 'react';
import { PaymentData } from '../types';

interface SuccessScreenProps {
  paymentData: PaymentData;
  onClose: () => void;
}

const SuccessScreen: React.FC<SuccessScreenProps> = ({ paymentData, onClose }) => {
  return (
    <div className="simplipay-step-container simplipay-success">
      <button className="close-btn top-right" onClick={onClose}>×</button>

      <div className="simplipay-success-content">
        <div className="success-icon">✓</div>
        <h2>Payment Successful!</h2>
        <p className="success-message">
          You paid {paymentData.currency} {paymentData.amount.toLocaleString()} to{' '}
          {paymentData.merchantName || 'SimpliPay'}
        </p>
        <p className="transaction-ref">
          Ref: {paymentData.transactionRef}
        </p>
      </div>

      <button className="simplipay-button" onClick={onClose}>
        Done
      </button>

      <div className="simplipay-footer">
        <span>🔒 Secured by <strong>SimpliPay</strong></span>
      </div>
    </div>
  );
};

export default SuccessScreen;
